const COMPLETE_MARKER = /[ \t]*\[memory:\d{1,9}\]/g;
// A marker split across stream deltas leaves a prefix such as "[mem" or
// "[memory:1" at the end of the text until the rest arrives. Finished text can
// legitimately end in such a prefix, so it is stripped only while streaming.
const TRAILING_PARTIAL_MARKER =
  /[ \t]*\[(?:m(?:e(?:m(?:o(?:r(?:y(?::\d{0,9})?)?)?)?)?)?)?$/;

/** @registry Removes the `[memory:N]` markers F.I.R.E. appends to a reply that used memory notes; with `streaming`, also hides a marker still cut off at the end of the text. Use on assistant text before it is displayed, copied, exported, or printed. */
export const stripMemoryMarkers = (text: string, streaming = false): string => {
  const stripped = text.replace(COMPLETE_MARKER, '');
  return streaming ? stripped.replace(TRAILING_PARTIAL_MARKER, '') : stripped;
};
